/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks on the Hamburger menu on the NavBar header
 *
 * &nbsp;
 */
export class HamburgerMenuNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-menu-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks on the Search Sitters option on the NavBar header
 *
 * &nbsp;
 */
export class SearchSittersNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-menu-search-sitters';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks on the Become a Sitter option on the NavBar header
 *
 * &nbsp;
 */
export class BecomeASitterNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-menu-become-sitter';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks on the Dog Training option on the NavBar header
 *
 * &nbsp;
 */
export class DogTrainingNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-dog-training';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks on the Grooming option on the NavBar header
 *
 * &nbsp;
 */
export class GroomingNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-grooming';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks on the Help option on the NavBar header
 *
 * &nbsp;
 */
export class HelpNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-help';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks one of the Our Services options on the NavBar header
 *
 * &nbsp;
 */
export class OurServicesSelectServiceNavBarClick extends AnalyticsEvent {
  eventName = 'navigation-our-services-select-service';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;

  constructor(eventProperties: { serviceType: string }) {
    super(eventProperties);
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks the lenguage selector option on the NavBar header
 *
 * &nbsp;
 */
export class LenguageSelectorNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-language-selector';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a user clicks the Join Now CTA on the NavBar header (mobile web)
 *
 * &nbsp;
 */
export class JoinNowNavBarClick extends AnalyticsEvent {
  eventName = 'navbar-join-now-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;
}
